import type { ActionInput } from "../ActionInput.js";
import {
  triageSelectionIsMca,
  triageSelectionIsSection136,
} from "../helpers.js";

export function calculateFormDetailsActions(actionInput: ActionInput) {
  return {
    canAdd:
      triageSelectionIsSection136(actionInput) ||
      triageSelectionIsMca(actionInput),
  };
}
